import api from "../services/api/axiosService";
import { atom, getDefaultStore } from "jotai";
import { GetCoursepartsResponse } from "./domain/GetCoursepartsResponse";
import { produce } from "immer";
import { waitRippleservice } from "src/services/WaitRippleService";

const store = getDefaultStore();

const initialState: GetCoursepartsResponse = {
    EditParts: [],
    OwnedParts: [],
    Loading: false
}

export const allFoundPartsAtom = atom<GetCoursepartsResponse>(initialState);
allFoundPartsAtom.debugLabel = "allFoundPartsAtom";



const endPoints = {
    GET_PARTS: (searchText: string) => `/author/courseparts?name=${encodeURIComponent(searchText)}`,
    GET_LAST_PARTS: (limit: number) => `/author/courseparts/${limit}/getlast`,
}

export class CoursePartCollectionService {

    public removePart(partId: string) {

        const state = store.get(allFoundPartsAtom);
        const newState = produce(state, draft => {
            draft.EditParts = draft.EditParts.filter(p => p.Id !== partId);
            draft.OwnedParts = draft.OwnedParts.filter(p => p.Id !== partId);
        });

        store.set(allFoundPartsAtom, newState);
    }

    public async fetchCourseParts(searchText: string, force?: boolean) {

        if (!force) {
            const state = store.get(allFoundPartsAtom);
            if (state.EditParts.length > 0 || state.OwnedParts.length > 0) {
                return null;
            }
        }

        try {
            waitRippleservice.setState(true);
            store.set(allFoundPartsAtom, { ...initialState, Loading: true });

            if (searchText && searchText.length > 2) {

                const response = await api.get<GetCoursepartsResponse>(endPoints.GET_PARTS(searchText))
                if (response && response.data) {
                    const data = { ...response.data, Loading: false };
                    store.set(allFoundPartsAtom, data);
                } else {
                    store.set(allFoundPartsAtom, initialState);
                }
                return null;
            }
            else {
                // clear all results
                store.set(allFoundPartsAtom, { EditParts: [], OwnedParts: [], Loading: false });
            }

            return null;

        } catch (error: any) {
            if (error.handled) {
                store.set(allFoundPartsAtom, initialState);
            }
            store.set(allFoundPartsAtom, { EditParts: [], OwnedParts: [], Loading: false });
            console.error(error);
            return null;

        }
        finally {
            waitRippleservice.setState(false);
        }
    }

    public clearCollection() {
        store.set(allFoundPartsAtom, initialState);
    }
}
const coursePartCollectionService = new CoursePartCollectionService();
export default coursePartCollectionService;